module.exports = __webpack_public_path__ + "static/social-media-logo-9660866dada8198ad2b92f5b38a7d4ac.png";